import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { PagedResultGeneric, PagedResult } from 'src/app/shared';
import { Subscription } from 'rxjs';
import { ProfileEvent } from '../../shared/model/profile-event.model';

@Component({
  selector: 'wl-profile-view-events-activity',
  templateUrl: 'profile-view-events.component.html',
  styleUrls: ['profile-view-events.component.css'],
  standalone: false,
})
export class ProfileViewEventsComponent implements OnInit, OnChanges, OnDestroy {
  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;
  private _pageSize: number = 5;

  public displayAttended = false;

  @Input() public profileId: number;
  @Input() public orgInd: boolean;

  public pagedProfileEvents: PagedResultGeneric<ProfileEvent>;
  public eventActivities: Array<ProfileEvent>;
  public showPaging = true;

  public constructor(profileService: ProfileService, observationService: ObservationService) {
    this._profileService = profileService;
    this._observationService = observationService;
    this.pagedProfileEvents = new PagedResult();
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadData(true);
  }

  ngOnChanges(changes) {
    if (changes['profileId'] && !changes['profileId'].firstChange) {
      this.loadData(true);
    }
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  toggleEventDisplay(displayAttended: boolean) {
    this.displayAttended = displayAttended;
    this.pagedProfileEvents.CurrentPageNumber = 1;
    this.getDisplayData();
  }

  private getDisplayData() {
    let eventActivities = this.eventActivities;
    if (this.displayAttended) {
      eventActivities = this.eventActivities.filter((event) => event.Attended == true);
    } else if (this.orgInd || !this.displayAttended) {
      eventActivities = this.eventActivities;
    }

    let startIndex = (this.pagedProfileEvents.CurrentPageNumber - 1) * this._pageSize;
    let endIndex = startIndex + this._pageSize;

    let result = {} as PagedResultGeneric<ProfileEvent>;

    result.Result = eventActivities.slice(startIndex, endIndex);
    result.PageSize = this._pageSize;
    result.CurrentPageNumber = this.pagedProfileEvents.CurrentPageNumber;
    result.TotalPages = Math.ceil(eventActivities.length / this._pageSize);
    this.pagedProfileEvents = result;

    this.showPaging = this.pagedProfileEvents.TotalPages > 1;
  }

  private profileUpdated(id: number) {
    if (id !== this.profileId) {
      this.loadData(true);
    }
  }

  private loadData(forceRefresh?: boolean) {
    if (forceRefresh) {
      this._profileService.getProfileEventActivity(this.profileId).then((data: ProfileEvent[]) => {
        this.eventActivities = data;
        this.pagedProfileEvents.CurrentPageNumber = 1;
        this.getDisplayData();
      });
    }
  }

  public onPagingEvent(page: number) {
    this.pagedProfileEvents.CurrentPageNumber = page;
    this.getDisplayData();
  }
}
